import Script, { ScriptProps } from 'next/script';
import { YOTPO_APP_KEY } from '~/services/yotpo';

export const YotpoScript: React.FC = (props: Omit<ScriptProps, 'src'>) => (
    <Script
        id="yotpo"
        type="text/javascript"
        strategy="lazyOnload"
        {...props}
        src={`https://cdn-widgetsrepository.yotpo.com/v1/loader/${YOTPO_APP_KEY}`}
    />
);
